import React from 'react';
import { SettingsBreadcrumbs } from "../settingsModule";
import { Breadcrumb } from "../../shared/web/layout/Breadcrumbs";
import InnerBlock from "../../shared/web/layout/InnerBlock";
import TabSelector from "../../shared/widgets/TabSelector/TabSelector";
import GmailWidget from "./GmailWidget";
import { useParams } from "react-router-dom";
import useSettingsNavigator from "../settingsNavigator";
import CustomDomainWidget from "./CustomDomainWidget";
import { useAuthorizationChecker } from "authorization-scope";
import { TeamPermission } from "nekst-api";

export enum EmailSetupPage {
  GMAIL = 'gmail',
  CUSTOM = 'custom',
}

function useEmailPage() {
  const { type } = useParams();

  if (type === EmailSetupPage.CUSTOM) {
    return EmailSetupPage.CUSTOM;
  } else {
    return EmailSetupPage.GMAIL;
  }
}

function EmailSetupTabs() {

  const page = useEmailPage();

  const settingsNavigator = useSettingsNavigator();

  const { isGranted } = useAuthorizationChecker();


  return (
    <TabSelector
      activeOption={page}
      onSelected={(value) => {
        settingsNavigator.openEmailSetupPage(value);
      }}
      isDisabled={!isGranted(TeamPermission.MANAGE_EMAIL_CONFIGURATION)}
      options={[
        {
          value: EmailSetupPage.GMAIL,
          label: 'Gmail',
        },
        ...isGranted(TeamPermission.MANAGE_EMAIL_CONFIGURATION) ? [{
          value: EmailSetupPage.CUSTOM,
          label: 'Custom Domain',
        }] : [],
      ]}
    />
  )
}


export default function UnifiedEmailPage() {

  const page = useEmailPage();

  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Email Setup" />
      </SettingsBreadcrumbs>
      <InnerBlock title="Email Setup">
        <EmailSetupTabs />
        {page === EmailSetupPage.GMAIL && <GmailWidget />}
        {page === EmailSetupPage.CUSTOM && <CustomDomainWidget />}
      </InnerBlock>
    </>
  );
}
